<template>
  <base-widget class="passage-reference">
    <span slot="header">Passage Reference</span>
    <div slot="body">
      <input
        v-model="reference"
        v-on:keyup="handleKeyUp"
        v-on:click="handleClick"
        type="text"
        class="form-control form-control-sm"
      >
    </div>
    <div slot="help">
      <span v-tooltip="'Here you can adjust the number of passages displayed (e.g. T1-F20 or 1.1-1.9)'">
        <i class="fas fa-info-circle" />
      </span>
    </div>
  </base-widget>
</template>

<script>
import ReaderNavigationMixin from '../../mixins/ReaderNavigationMixin.vue';

export default {
  name: 'widget-passage-reference',
  mixins: [
    ReaderNavigationMixin,
  ],
  watch: {
    passage: {
      handler: 'setInputRef',
      immediate: true,
    },
  },
  computed: {
    passage() {
      return this.$store.getters['reader/passage'];
    },
  },
  data() {
    return {
      reference: '',
    };
  },
  methods: {
    setInputRef() {
      this.reference = this.passage.urn.reference;
    },
    handleKeyUp(e) {
      if (e.keyCode === 13) {
        this.$router.push(this.toRef(this.reference));
      } else {
        e.stopPropagation();
      }
    },
    handleClick(e) {
      const el = e.currentTarget;
      el.select();
    },
  },
};
</script>
